<div class="register-success-container">
  @if (codeVerified) {
    <app-loader [noMobileDisplay]="true" [relativePosition]="true"></app-loader>
    <div class="register-success-container__text-container">
      <h1 class="register-success-container__text-container__h1">
        {{ 'registerAppPhoneValidation_loaderValidationTitle' | translate }}
      </h1>
      <p class="register-success-container__text-container__p">
        {{ 'registerAppPhoneValidation_loaderValidationText' | translate }}
      </p>
      <p class="register-success-container__text-container__p">
        <a
          (click)="goToLogin()"
          class="rc-link hyperlink"
          appTracking="registration.loginClick"
          >{{ 'registerAppAccountCreation2' | translate }}</a
        >
      </p>
    </div>
  } @else {
    <app-logo />
    <div class="register-success-container__img-bloc">
      <img
        role="presentation"
        alt=""
        src="./assets/images/register_success.jpg"
      />
    </div>
    <div class="register-success-container__text-container">
      <h1 class="register-success-container__text-container__h1">
        {{ 'registerAppPhoneValidation_Title' | translate }}
      </h1>
      <p class="register-success-container__text-container__p">
        {{ 'registerAppPhoneValidation_introductionText' | translate }}
        @if (user && user.profile) {
          <span class="bold-text" data-cs-mask>{{
            user.profile.primaryPhone
          }}</span>
        }
      </p>
      <form
        [formGroup]="registerSuccessForm"
        (submit)="onSubmit()"
        class="rc-content-v-middle"
      >
        <div class="rc-dialog-form__input-primaryPhone">
          <rc-field
            id="registerSuccessFieldCode"
            [autocomplete]="'disabled'"
            [error]="error"
            [forceTypeNumber]="false"
            [placeholder]="
              'registerAppPhoneValidation_OTCCodeField' | translate
            "
            type="number"
            data-cs-mask
            formControlName="code"
            maxlength="50"
          ></rc-field>
          <rc-button
            [disabled]="registerSuccessForm.invalid || submitted"
            [name]="'registerAppPhoneValidation_ConfirmButton' | translate"
            type="submit"
          ></rc-button>
        </div>
      </form>
      <p class="register-success-container__text-container__p">
        {{ 'registerAppPhoneValidation_SendNewCodeText' | translate }}
      </p>
      <div class="register-success-container__link-container">
        <a
          id="registerPrimaryPhoneSendNewCode"
          (click)="sendVerificationCode()"
          class="rc-link"
          appTracking="registration.sendVerificationCode"
          rel="noreferrer"
        >
          {{ 'registerAppPhoneValidation_SendNewCodeButon' | translate }}
        </a>
        <app-contact-us-button
          appTracking="registration.contactSupport"
          labelKey="contactSupportPage_title"
        ></app-contact-us-button>
      </div>
    </div>
  }
</div>
